import React, { useState } from 'react';
import { ContentItem, ContentType } from '@memriti/shared';
import ByteCard from './ByteCard';

interface ByteLearningViewProps {
  content: ContentItem[];
  onComplete?: () => void;
}

const ByteLearningView: React.FC<ByteLearningViewProps> = ({ content, onComplete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < content.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (onComplete) {
      onComplete();
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  if (content.length === 0) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="text-gray-400 dark:text-gray-500 mb-4">
            <svg className="mx-auto h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No learning bytes available</h3>
          <p className="text-gray-500 dark:text-gray-400">
            No explanation, common mistakes, or tips & tricks content found for this topic.
          </p>
        </div>
      </div>
    );
  }

  const currentByte = content[currentIndex];

  return (
    <div className="w-full h-full min-h-[20rem] max-h-[calc(100vh-12rem)] flex flex-col">
      <ByteCard
        content={currentByte}
        onNext={handleNext}
        onPrevious={handlePrevious}
        currentIndex={currentIndex}
        totalCount={content.length}
      />
    </div>
  );
};

export default ByteLearningView;